var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4732 7.57039L48.4681 7.56529C44.271 3.38709 37.4663 3.38709 33.2692 7.56529L7.59945 33.1198C3.40241 37.298 3.40241 44.0722 7.59945 48.2504L7.60458 48.2555C11.8016 52.4337 18.6064 52.4337 22.8034 48.2555L48.4732 22.701C52.6702 18.5228 52.6702 11.7486 48.4732 7.57039Z",
    fill: "#DEE5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2944 27.9127L28.0388 17.7031L17.7832 27.9127L28.0388 38.1222L38.2944 27.9127Z",
    fill: "#9BABD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaster);
export default __webpack_public_path__ + "static/media/plaster.cc239a1ca335cfac4ad949b61b4ae67c.svg";
export { ForwardRef as ReactComponent };